import script from "./Middle.vue?vue&type=script&setup=true&lang=ts"
export * from "./Middle.vue?vue&type=script&setup=true&lang=ts"

import "./Middle.vue?vue&type=style&index=0&id=0c086716&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c086716"]])

export default __exports__